import React from 'react';
import { ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-20 lg:py-32" data-id="element-163">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.03)_0,_transparent_70%)]" data-id="element-164"></div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-165"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-166">
        <div className="max-w-4xl mx-auto text-center" data-id="element-167">
          <h2 className="font-['Space_Grotesk'] text-zinc-400 mb-4 tracking-wider" data-id="element-168">
            AI + HUMANS
          </h2>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-6xl font-light mb-6 leading-tight" data-id="element-169">
            Next Generation Intake for{' '}
            <span className="text-white" data-id="element-170">Law Firms</span>
          </h1>
          <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto font-light" data-id="element-171">
            The most complete legal intake service, where a team of experienced
            people and advanced AI ensures every lead gets personalized
            attention the moment they reach out. On any channel, 24/7, and in
            any language.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-172">
            <a href="https://bots.messagesimproved.com/sign-up-auth/?brand=lexsquire&intent=signup" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors flex items-center justify-center" data-id="element-173">
              Get Started
              <ArrowRight size={18} className="ml-2" data-id="element-174" />
            </a>
            <a href="https://calendly.com/lexsquire-info/30min" className="border border-white/20 text-white px-6 py-3 rounded-sm hover:bg-white/5 transition-colors" data-id="element-175">
              Schedule Demo
            </a>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mt-20" data-id="element-176">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-10" data-id="element-177">
          <div className="text-center" data-id="element-178">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-179">
              24/7
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-180">
              Availability
            </p>
          </div>
          <div className="text-center" data-id="element-181">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-182">
              100+
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-183">
              Languages
            </p>
          </div>
          <div className="text-center" data-id="element-184">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-185">
              5+
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-186">
              Communication Channels
            </p>
          </div>
          <div className="text-center" data-id="element-187">
            <p className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-188">
              &lt;30
            </p>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm mt-2" data-id="element-189">
              Second Response Time
            </p>
          </div>
        </div>
      </div>
    </section>;
};